import React, { useEffect, useState } from "react"
import { Toast, ToastHeader } from 'reactstrap';

const FormToast = (props) => {

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(props.show);

    const dismissAfter = parseInt(props.dismissAfter);
    if (!isNaN(dismissAfter)) {
      let timeout = setTimeout(() => { setShow(false) }, dismissAfter * 1000)

      return () => {
        clearTimeout(timeout);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Toast isOpen={show} className={props.className ?? ''}>
      <ToastHeader toggle={() => { setShow(!show) }} className={props.className ?? ''}>
      <span className="text-white">
          {props.message ?? ''}
        </span>
      </ToastHeader>
    </Toast>
  )
}

export default FormToast;